import { InfiniteData, useQueryClient } from "@tanstack/react-query";
import { use } from "react";
import { useNavigate } from "react-router";
import { BikeContext } from "../context/bikeContext";
import { useDeleteBike } from "../hooks/useBikes";
import { Bike, Paginated } from "../http/onlyclicksApi";
import Button from "./Button";
import Dialog from "./Dialog";

interface Props {
  bikeId: string;
  open: boolean;
  onClose: () => void;
}

const DeleteBikeDialog = ({ bikeId, open, onClose }: Props) => {
  const navigate = useNavigate();
  const mutation = useDeleteBike();
  const queryClient = useQueryClient();
  const { bike, setBike } = use(BikeContext);

  const tryFindNextBike = () => {
    const bikes = queryClient.getQueryData<InfiniteData<Paginated<Bike>>>([
      "inf-bikes",
    ]);
    const items = bikes?.pages.flatMap((page) => page.items) ?? [];
    return items.filter((i) => i.id !== bikeId)[0];
  };

  return (
    <Dialog
      open={open}
      size="small"
      onClose={() => {
        mutation.reset();
        onClose();
      }}
    >
      <Dialog.Title>Delete bike?</Dialog.Title>
      <Dialog.Content>
        The bike will be deleted immediately. This action cannot be undone.
      </Dialog.Content>
      <Dialog.Footer>
        <Button
          type="accent_secondary"
          buttonProps={{
            onClick: onClose,
          }}
        >
          Cancel
        </Button>
        <Button
          isLoading={mutation.isPending}
          type="accent"
          buttonProps={{
            type: "submit",
            disabled: mutation.isPending,
            onClick: () => {
              mutation.mutate(bikeId, {
                onSuccess: () => {
                  onClose();
                  navigate("/garage");
                  if (bike?.id === bikeId) {
                    const nextBike = tryFindNextBike();
                    setBike(nextBike);
                  }
                },
              });
            },
          }}
        >
          Delete
        </Button>
      </Dialog.Footer>
    </Dialog>
  );
};

export default DeleteBikeDialog;
